module.exports = __webpack_public_path__ + "static/media/Illus-SideVeggie.a693d2fe.png";